/*================ Custom Code ================*/
/*========== <tyler@floralacres.ca> ===========*/

/* Sticky Nav JS with no Announcement bar - causing CLS issues
function headerSize() {
  var $headerHeight = $('div#shopify-section-header').outerHeight();
  $('#PageContainer').css('padding-top', $headerHeight);
}

$(window).on("load", headerSize);
$(window).on("resize", $.debounce(500, headerSize));

$(window).scroll(function() {
  scroll = $(window).scrollTop();
  if (scroll >= 1) {
    $('.site-header').css('top', '0');
  } else {
    $('.site-header').css('top', 'initial');
  }
}); */



/* Sticky Nav JS with Announcement bar - this block causing CLS issues
function headerSize() {
  var $headerHeight = $('div#shopify-section-header').outerHeight();
  $('#PageContainer').css('padding-top', $headerHeight);
}

$(window).on("load", headerSize);
$(window).on("resize", $.debounce(500, headerSize));

*/

// Open External Links in New Window
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

const callback = () => {
    const nextPageLink = document.querySelector("[data-paginate-next]");
    const pageCount = nextPageLink.getAttribute("href").split("?page=")[1];

    if (typeof pageCount === "undefined") {
      nextPageLink.classList.add("hide");
    }
  };

// AJAXinate Infinite Scroll 
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
  	container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    method: 'click',
    offset: 0,
    loadingText: 'Loading...',
    callback: callback
  });
});


// BIS to Peek Mode
//$('.product-info-container').append('<div class="product-form__item product-form__item--submit" id="bis-notify-me"></div>');                                       


